// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/Panelright/Panelright.css
// module id = 1878
// module chunks = 193